// components/EmployeeModal.jsx
import React from "react";
import { Modal, Button } from "antd";

/**
 * Props:
 * - visible, onClose, title
 * - children: konten modal (biasanya <CustomForm ref={formRef} ... />)
 * - formRef: ref yang diberikan ke CustomForm (forwardRef)
 * - submitText: text tombol utama
 * - showFooter: boolean
 * - readOnly: boolean
 * - onDelete: function (optional)
 */
const EmployeeModal = ({
  visible,
  onClose,
  title,
  children,
  formRef,
  submitText = "Submit",
  showFooter = true,
  readOnly = false,
  onDelete,
}) => {
  const handlePrimary = (e) => {
    e && e.preventDefault && e.preventDefault();
      console.log("EmployeeModal handlePrimary; formRef:", formRef && formRef.current);

    // If delete button was expected, that has its own handler.
    if (onDelete) {
        // console.log("EmployeeModal handlePrimary; formRef:", formRef && formRef.current);

      // do nothing here for primary (we show a separate Delete button)
      return;
    }

    // If a formRef is provided, trigger the antd form submit
    if (formRef && formRef.current && typeof formRef.current.submit === "function") {
      formRef.current.submit();
      return;
    }
      console.warn("formRef not ready yet");


    // Fallback: if there is no formRef, just close
    onClose && onClose();
  };

  const handleDelete = () => {
    if (typeof onDelete === "function") {
      onDelete();
      onClose && onClose();
    }
  };

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onClose}
      footer={
        showFooter && (
          <>
            <Button onClick={onClose}>Cancel</Button>

            {onDelete ? (
              <Button type="primary" danger onClick={handleDelete}>
                Delete
              </Button>
            ) : (
              !readOnly && (
                <Button type="primary" onClick={handlePrimary}>
                  {submitText}
                </Button>
              )
            )}
          </>
        )
      }
    >
      {/* render content directly so AntD Form works normally */}
      {children}
    </Modal>
  );
};

export default EmployeeModal;
